import { alpha } from "@mui/material";
function createLightPalette(tidalColors) {
  return {
    // ---------------------------------------------------------------------
    // Default Semantic
    // ---------------------------------------------------------------------
    primary: {
      light: tidalColors.oceanBlue[400],
      main: tidalColors.oceanBlue[500],
      dark: tidalColors.oceanBlue[700],
      contrastText: "#FFFFFF"
    },
    secondary: {
      light: tidalColors.oceanBlue[50],
      main: tidalColors.oceanBlue[100],
      dark: tidalColors.oceanBlue[200],
      contrastText: tidalColors.oceanBlue[800]
    },
    error: {
      light: tidalColors.lobsterRed[400],
      main: tidalColors.lobsterRed[500],
      dark: tidalColors.lobsterRed[600],
      contrastText: "#FFFFFF"
    },
    warning: {
      light: tidalColors.sunnyYellow[400],
      main: tidalColors.sunnyYellow[500],
      dark: tidalColors.sunnyYellow[800],
      contrastText: tidalColors.sunnyYellow[900]
    },
    info: {
      light: tidalColors.oceanBlue.A100,
      main: tidalColors.oceanBlue.A200,
      dark: tidalColors.oceanBlue.A700,
      contrastText: "#112A47"
    },
    success: {
      light: tidalColors.jadeGreen[400],
      main: tidalColors.jadeGreen[500],
      dark: tidalColors.jadeGreen[700],
      contrastText: tidalColors.jadeGreen[900]
    },
    seafoam: {
      light: tidalColors.seafoamTeal[400],
      main: tidalColors.seafoamTeal[500],
      dark: tidalColors.seafoamTeal[700],
      contrastText: tidalColors.seafoamTeal[900]
    },
    // ---------------------------------------------------------------------
    // Medium Semantic
    // ---------------------------------------------------------------------
    errorMedium: {
      light: tidalColors.lobsterRed[200],
      main: tidalColors.lobsterRed[300],
      dark: tidalColors.lobsterRed[400],
      contrastText: tidalColors.lobsterRed[900]
    },
    warningMedium: {
      light: tidalColors.sunnyYellow[200],
      main: tidalColors.sunnyYellow[300],
      dark: tidalColors.sunnyYellow[400],
      contrastText: tidalColors.sunnyYellow[900]
    },
    infoMedium: {
      light: "#A7D0FF",
      main: "#84BDFF",
      dark: tidalColors.oceanBlue.A100,
      contrastText: "#112A47"
    },
    successMedium: {
      light: tidalColors.jadeGreen[200],
      main: tidalColors.jadeGreen[300],
      dark: tidalColors.jadeGreen[400],
      contrastText: tidalColors.jadeGreen[900]
    },
    seafoamMedium: {
      light: tidalColors.seafoamTeal[200],
      main: tidalColors.seafoamTeal[300],
      dark: tidalColors.seafoamTeal[400],
      contrastText: tidalColors.seafoamTeal[900]
    },
    // ---------------------------------------------------------------------
    // Medium Semantic
    // ---------------------------------------------------------------------
    errorLight: {
      light: tidalColors.lobsterRed[50],
      main: tidalColors.lobsterRed[100],
      dark: tidalColors.lobsterRed[200],
      contrastText: tidalColors.lobsterRed[800]
    },
    warningLight: {
      light: tidalColors.sunnyYellow[50],
      main: tidalColors.sunnyYellow[100],
      dark: tidalColors.sunnyYellow[200],
      contrastText: tidalColors.sunnyYellow[900]
    },
    infoLight: {
      light: "#ECF5FF",
      main: "#DBECFF",
      dark: "#A7D0FF",
      contrastText: "#112A47"
    },
    successLight: {
      light: tidalColors.jadeGreen[50],
      main: tidalColors.jadeGreen[100],
      dark: tidalColors.jadeGreen[200],
      contrastText: tidalColors.jadeGreen[900]
    },
    seafoamLight: {
      light: tidalColors.seafoamTeal[50],
      main: tidalColors.seafoamTeal[100],
      dark: tidalColors.seafoamTeal[200],
      contrastText: tidalColors.seafoamTeal[800]
    },
    // ---------------------------------------------------------------------
    // Others
    // ---------------------------------------------------------------------
    action: {
      active: alpha("#091B2A", 0.56),
      activatedOpacity: 0.56,
      disabled: alpha("#091B2A", 0.38),
      disabledOpacity: 0.38,
      disabledBackground: alpha("#091B2A", 0.12),
      focus: alpha("#091B2A", 0.12),
      focusOpacity: 0.12,
      hover: alpha("#091B2A", 0.04),
      hoverOpacity: 0.04,
      selected: alpha("#091B2A", 0.08),
      selectedOpacity: 0.08
    },
    grey: {
      A100: "#D5D5D5",
      A200: "#AAAAAA",
      A400: "#616161",
      A700: "#303030"
    },
    divider: tidalColors.slateBlueGray[100],
    background: {
      paper: tidalColors.cloudGray[50],
      default: tidalColors.cloudGray[100],
      default2: tidalColors.cloudGray[200],
      default3: tidalColors.cloudGray[300]
    },
    text: {
      primary: alpha(tidalColors.slateBlueGray[900], 0.85),
      secondary: alpha(tidalColors.slateBlueGray[900], 0.7),
      disabled: alpha(tidalColors.slateBlueGray[900], 0.55),
      contrastText: tidalColors.slateBlueGray[900]
    },
    tidalColors,
    workwaveBlue: "#002D5C"
  };
}
export {
  createLightPalette
};
//# sourceMappingURL=createLightPalette.js.map
